export const convertValueToName = (array, value) => {
  let name = null
  array.forEach((d) => {
    if ((d.value || d.code) === value) {
      name = d.name
    }
  })
  return name
}
